<template>
  <div data-testid="sf-comment-list">
    <div
      class="tw-flex tw-flex-col tw-justify-center"
      :class="[theme.commentsBandBackground, bleedClasses]"
    >
      <div
        v-if="toggleable"
        class="
          tw-w-full
          tw-text-sf-primary-dark
          tw-py-1
          tw-cursor-pointer
          tw-text-center
          tw-leading-5
          tw-border-solid
          tw-border-x-0
          tw-border-t-0
        "
        :class="[
          theme.commentDivider,
          !props.slim || expanded ? 'tw-border-b' : 'tw-border-b-0',
        ]"
        @click="toggleDropdown"
      >
        <span v-if="!expanded">{{ showCommentsCopy }}</span>
        <span v-else>{{ hideCommentsCopy }}</span>
      </div>
      <div v-show="expanded">
        <slot name="toggleable" />
      </div>
      <slot name="default" :expanded="expanded" />
      <div
        v-if="showMarkAsRead"
        class="
          tw-w-full
          tw-py-1.5
          tw-cursor-pointer
          tw-text-center
          tw-border-solid
          tw-border-t
          tw-border-x-0
          tw-border-b-0
          tw-relative
        "
        :class="[theme.markAsReadText, theme.commentDivider]"
        @click="emit('markAsRead')"
      >
        <i class="fa fa-envelope-open"></i>
        {{ I18n.t('communication.comments.mark_thread_as_read') }}
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { DividerClasses } from '@app/shared/constants'
import { commsTheme } from '@app/shared/comms-theme'

const expanded = ref(false)
const I18n = useI18n()
const theme = commsTheme()

interface Props {
  toggleableCount: number
  showMarkAsRead?: boolean
  slim?: boolean
  bleed?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  showMarkAsRead: false,
  slim: false,
  bleed: false,
})

const bleedClasses = computed(() => ({
  'tw-rounded-lg': !props.bleed,
  [DividerClasses.TOP]: props.bleed,
}))

const toggleable = computed(() => {
  return props.toggleableCount > 0
})

const remainingCount = computed(() => {
  return props.toggleableCount
})

const toggleDropdown = () => {
  expanded.value = !expanded.value
}

const hideCommentsCopy = computed(() => {
  if (props.slim) {
    return window.I18n.t(
      'communication.comments.show_all_toggle.hide_replies',
      { count: remainingCount.value }
    )
  }
  return window.I18n.t('communication.comments.show_all_toggle.hide_old')
})

const showCommentsCopy = computed(() => {
  if (props.slim) {
    return window.I18n.t(
      'communication.comments.show_all_toggle.show_replies',
      { count: remainingCount.value }
    )
  }
  return window.I18n.t(
    'communication.comments.show_all_toggle.show_amount_more',
    {
      amount: remainingCount.value,
    }
  )
})

const emit = defineEmits<{ markAsRead: [] }>()

defineExpose({ expand: () => (expanded.value = true) })
</script>
